import React from 'react';
import styled from 'styled-components';

export const SVG = styled.svg`
  path {
    fill: ${({ theme }) => theme.colors.text01};
  };

  &.blue path {
    fill: ${({ theme }) => theme.colors.text05};
  };

  &.open {
    transform: rotate(180deg);
  };
`;

export const ArrowIcon = (props) => (
  <SVG
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="11"
    height="6"
    viewBox="0 0 11 6"
  >
    <g fill="none" fillRule="evenodd">
      <g>
        <path
          d="M520.771 179.219c-.305-.292-.804-.292-1.11 0l-4.161 3.973-4.161-3.973c-.306-.292-.805-.292-1.11 0-.305.29-.305.768 0 1.06l4.716 4.502c.305.292.805.292 1.11 0l4.716-4.503c.305-.291.305-.768 0-1.06z"
          transform="translate(-510 -179)"
        />
      </g>
    </g>
  </SVG>
);


